import distributorTemplate from './page/distributor/distributor.html';
import addressTemplate from './page/address/address.html';
import distKitsSelectTemplate from './page/dist-kits-select/dist-kits-select.html';
import preferredCustomerTemplate from './page/preferred-customer/preferred-customer.html';
import customerTemplate from './page/customer/customer.html';
import idImageUploadTemplate from './page/id-image/id-image.html';

export default function enableCheckoutAngularRouter() {
    angular.module('checkout').config(
        [
            '$routeProvider',
            function (
                $routeProvider
            ) {
                $routeProvider
                    .when(
                        '/checkout/distributor', {
                            template: distributorTemplate,
                        }
                    )
                    .when(
                        '/checkout/cart', {
                            controller: [
                                '$window', ($window) => {
                                    //Redirect to new React-driven cart page if we wind up at this old angular my-cart URL
                                    $window.location.replace('/cart#/my-cart');
                                }
                            ],
                            template: '<div></div>'
                        }
                    )
                    .when(
                        '/id-image-upload', {
                            template: idImageUploadTemplate,
                        }
                    )
                    .when(
                        '/checkout/address', {
                            template: addressTemplate,
                        }
                    )
                    .when(
                        '/checkout/dist-kits-select', {
                            template: distKitsSelectTemplate,
                        }
                    )
                    .when(
                        '/checkout/preferred-customer', {
                            template: preferredCustomerTemplate,
                        }
                    )
                    .when(
                        '/checkout/customer', {
                            template: customerTemplate,
                        }
                    )
                    .when(
                        '/receipt/:orderNumber', {
                            controller: [
                                '$window', '$routeParams', function ($window, $routeParams) {
                                    $window.location.replace('/receipt?orderNumber=' + $routeParams.orderNumber);
                                },
                            ],
                            template: '<div></div>',
                        }
                    )
                    //@todo delete this later
                    .otherwise(
                        {
                            redirectTo: '/checkout/cart',
                        }
                    );
            },
        ]
    );
}
